module.exports = __webpack_public_path__ + "img/swiper-23.707c10c1.png";